import { Button, Flex } from 'front-commons/ds';
import { useEffect, useState } from 'react';
import * as workerTimers from 'worker-timers';
import { UNDO_TIME } from 'containers/Drawers/PromotionSuggestion/helpers';
import { UndoSuggestionCardProps } from './interfaces';
import { Container } from './styles';
import { Typography, Icon } from 'hype-ds';

export default function UndoSuggestionCard({ loading, onUndo, onTimeout }: UndoSuggestionCardProps) {
	const [isVisible, setIsVisible] = useState(true);

	const handleUndo = () => {
		onUndo();
		if (loading === undefined) setIsVisible(false);
	};

	useEffect(() => {
		let timer: number;

		if (isVisible) {
			timer = workerTimers.setTimeout(() => {
				if (loading) return;

				setIsVisible(false);
				onTimeout?.();
			}, UNDO_TIME);
		}

		return () => workerTimers.clearTimeout(timer);
	}, []);

	if (!isVisible) return null;

	return (
		<Container
			gap="0"
			width="100%"
			overflow="hidden"
			direction="column"
			borderRadius="8px"
			justifyContent="space-between"
			backgroundColor="--info-surface"
		>
			<Flex padding="12px 16px" alignItems="center" justifyContent="space-between">
				<Flex gap="8px" alignItems="center">
					<Icon name="check_circle" size="20px" color="--semantic-info-base" />
					<Typography.Paragraph.S lh100>
						{loading ? 'Desfazendo' : 'Substituição realizada com sucesso!'}
					</Typography.Paragraph.S>
				</Flex>

				<Button variant="text" size="small" onClick={handleUndo} loading={loading} loadingProps={{ size: '16' }}>
					<Typography.Label.S color="--text-link">Desfazer</Typography.Label.S>
				</Button>
			</Flex>

			<Flex width="100%" height="4px">
				{!loading && <Flex data-component-name="progress-bar" backgroundColor="--semantic-progress-base" />}
			</Flex>
		</Container>
	);
}
